import { createSlice } from "@reduxjs/toolkit";

const authSlice=createSlice({

name:'auth',
initialState:{
data:[],
token:'',
userType:'',
userId:''


},
reducers:{

register(state,action){
    
const {token,type,id,address}=action.payload;
localStorage.setItem('token',token);
localStorage.setItem('userType',type);
localStorage.setItem('userId',id);
if(address){
  localStorage.setItem('address',address.user_city+address.zone_state+address.zone_zipcode)
localStorage.setItem('zone_price',address.zone_price);
}
state.token=token;
state.userType=type;
state.userId=id;
state.data=(action.payload);

},
logout(){

    localStorage.removeItem('token');
    localStorage.removeItem('USER_TYPE');
    localStorage.removeItem('AUTH_NAME');
    localStorage.removeItem('User_id');
    localStorage.removeItem('address');
    localStorage.removeItem('zone_price');
    return {  // Return a new object representing the initial state
        data: [],
        token: '',
        userType: '',
        userId: ''
      };
   
}


}

})
export const {register,logout}=authSlice.actions
export default authSlice.reducer